// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"7e203351","239":"2f768d6b","455":"fc99e4cb","782":"c9210c07","977":"51a1344e"}[chunkId] + ".chunk.js";
};